/** Cache names shared by the service worker's runtime routes (vite.config.ts) and the full offline download (F12). */
export const CACHES = { assets: 'marrow-assets', meta: 'marrow-meta', content: 'marrow-content', pages: 'marrow-pages' } as const;

/** Which runtime cache serves a URL path. Must agree with the SW's routes in vite.config.ts. */
export function cacheFor(url: string): string {
  if (/\/assets\/.+\.glb$/.test(url)) return CACHES.assets;
  if (/\/assets\/assets\.json$/.test(url)) return CACHES.meta;
  return CACHES.content;
}
